module.exports = "h1 {\n    margin-bottom: 20px;\n}\n\n.about-us-text {\n    margin-top: 20px;\n}"